'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TagPickerGroup", {
    enumerable: true,
    get: function() {
        return TagPickerGroup;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTagPickerGroup = require("./useTagPickerGroup");
const _reacttags = require("@fluentui/react-tags");
const _renderTagPickerGroup = require("./renderTagPickerGroup");
const _useTagPickerGroupStylesstyles = require("./useTagPickerGroupStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TagPickerGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTagPickerGroup.useTagPickerGroup_unstable)(props, ref);
    (0, _useTagPickerGroupStylesstyles.useTagPickerGroupStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTagPickerGroupStyles_unstable')(state);
    return (0, _renderTagPickerGroup.renderTagPickerGroup_unstable)(state, (0, _reacttags.useTagGroupContextValues_unstable)(state));
});
TagPickerGroup.displayName = 'TagPickerGroup';
